export default "__VITE_ASSET__BvUoD5Vi__"